<template>
<!-- <div class="container">

    <div class="row">
                <hr style="border-top: 1px solid #505F74;">

      <div 
        v-for="(image, index) in images" 
        :key="index" 
        class="col-6 col-md-4 col-lg-2 p-2"
      >
        <img :src="image" class="img-fluid rounded shadow w-50" alt="Gallery Image ">
      </div>
              <hr style="border-top: 1px solid #505F74;">

    </div>
  </div> -->
<div class="footer-mini pt-0 pt-md-0 pt-lg-0 pb-0 pb-md-2 pb-lg-2 footer-bg" :class="[this.IsChangefooter,this.IspageName]">
    <hr style="border-top: 1px solid #505F74;">

    <div class="container hk-container-padding">
        <div class="pb-4 pt-0 pt-md-4 pt-lg-4  row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center d-block my-auto">
                <ul class="list-inline mb-0">
                    <li class="list-inline-item hk-cursor-pointer">
                        <router-link :to="'/privacypolicy'" target="_blank">{{$t('footer.hk_privacy_policy')}}</router-link>
                    </li>
                    <!-- <li class="list-inline-item">|</li>
                    <li class="list-inline-item hk-cursor-pointer">
                        <div data-bs-toggle="modal" data-bs-target="#trust">{{$t('footer.hk_terms_conditions')}}</div>
                    </li> -->
                    
                       <li class="list-inline-item">|</li>
                    <li class="list-inline-item hk-cursor-pointer">
                        <router-link :to="'/terms&conditions'" target="_blank">Terms & Conditions</router-link>
                    </li>
                    <li class="list-inline-item">|</li>
                    <li class="list-inline-item hk-cursor-pointer">
                        <router-link :to="'/isms-policy'" target="_blank">{{$t('footer.hk_isms_policy')}}</router-link>
                    </li>
                      <li class="list-inline-item">|</li>
                    <li class="list-inline-item hk-cursor-pointer">
                        <router-link :to="'/privacy-objectives'" target="_blank">Privacy Objectives</router-link>
                    </li>
                    
                </ul>
            </div>
        

        </div>
    </div>

   

    <!-- cookies -->
    <div class="cookies-bg" v-if="this.cookiesDialogVisible">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="cookies-header">
                        <p>{{ $t('footer.cookies_text')}}</p>
                        <button class="btn hk-btn-cookies" @click="checkRestrickt()">{{ $t('all_hk_btn.btn_got_it')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- toast  -->
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 111">
        <div id="liveToast" class="toast" :class="showToast? 'show':'hide'">
            <div class="toast-header">
                <!-- <img src="@/assets/career/waving_hand.svg" class="rounded me-2 hand" alt="hand"> -->
                <strong class="me-auto toast-color">{{$t('footer.right_side_heading')}}</strong>
                <!-- <small>11 mins ago</small> -->
                <button @click="clostToast()" type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"> </button>
            </div>
            <div class="toast-body">
                <p class="mb-0 toast-color">{{ $t('footer.right_side_popup_text') }}</p>
                <!-- <p class="mb-0 toast-color">Contact the Sales Team</p> -->
                <button class="btn hk-btn-toast" @click="goToContact()">{{$t('all_hk_btn.btn_contact_team')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
    components: {},
    name: 'FooterMini',
    data() {
        return {
            cookiesDialogVisible: false,
            showToast: false,
            IsChangefooter: '',
            images: [
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png'),
                require('@/assets/expert-review/expidia.png')
            ]
        }
    },
    computed: {
        //     IsChangefooter() {
        //     return this.$i18n.locale;
        // },
        IspageName() {
            return this.$route.name;
        }
    },
    beforeMount() {
        // console.log(this.$route.mobileMode);

        if (sessionStorage.getItem("restrictionPopup") == null) {
            this.cookiesDialogVisible = true;

        }
        if (sessionStorage.getItem("toastPopup") == null) {
            setTimeout(() => {
                this.showToast = true;
            }, 45000)
        }
    },
    mounted() {

    },

    methods: {

        checkRestrickt() {
            if (sessionStorage.getItem("restrictionPopup") == null) {
                this.cookiesDialogVisible = false;
                sessionStorage.setItem("restrictionPopup", "true");

                window.dataLayer = window.dataLayer || [];

                function gtag() {
                    dataLayer.push(arguments)
                };
                gtag('js', new Date());
                gtag('config', 'G-5NFP1NE0L9');
                // old - G-Z32VVYFV0J

            }
        },
        goToContact() {
            if (sessionStorage.getItem("toastPopup") == null) {
                this.$router.push({
                    path: 'contact-team'
                });
                this.showToast = false;
                sessionStorage.setItem("toastPopup", "true");

            }
        },
        clostToast() {
            if (sessionStorage.getItem("toastPopup") == null) {
                this.showToast = false;
                sessionStorage.setItem("toastPopup", "true");
            }
        },
  
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/config/variables.scss';
@import '@/assets/sass/main.scss';

.footer-mini {
    background: #fff;
}

.footer-mini.IotKey {
    background: #F5F9F8;
}

.footer-mini.IT.HomePage {
    background: #FCF9F6;
}

.footer-mini.TH.HomePage {
    background: #F1F0F4;
}

.footer-mini.ES.HomePage {
    background: #FAF7EF;
}

.footer-mini.DE.HomePage {
    backgrgetUseound: #FFFDF9;
}

.footer-mini.FR.HomePage {
    background: #F7F8FB;
}

.footer-mini.africa.HomePage {
    background: #F1F2E6E6;
}

.footer-mini {

    position: relative;
    margin-top: -1rem;

    .list-inline {
        .list-inline-item {
            color: $p-color;
            font-size: 14px;

            a {
                color: $p-color;
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}

.hand {
    width: 26px;
}

.toast-color {
    color: $main-headings;
}

.toast-header {
    font-size: 18px;
}

.hk-btn-toast {
    background: $hk-blue !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    padding: 8px !important;
    line-height: unset !important;
    letter-spacing: unset !important;
    margin-top: 5px;
}

#liveToast {
    border: unset;
    background: #fff;
}

.btn-close {
    background: transparent url('@/assets/logo/cross.svg') center/2em auto no-repeat;
    font-size: 14px;
}

.toast-body {
    .toast-color {
        font-size: 16px;
    }

}

.toast {
    --bs-toast-max-width: 300px;
}

.list-inline-item:not(:last-child) {
    margin-right: 0.75rem;
}

.list-inline-item.text-white a {
    opacity: 1;
}

.list-inline-item.hk-list-inline-item a {
    opacity: 1;
}

.privacy-policy {

    h3 {
        font-size: 18px;
        font-weight: 700;
    }

    .modal-header {
        border-bottom: unset;

        .hk-btn-close {
            padding: 0;
            cursor: pointer;

            img {
                width: 40px;
            }
        }
    }

    .modal-body {
        max-height: 500px;
        overflow-y: auto;

    }

    .modal-content {
        padding: 0 2rem;
    }

    ul {
        li {
            list-style-type: none;
        }
    }

}

.modal-dialog {
    p {
        color: $main-headings;
    }
}

.cookies-bg {
    width: 100%;
    background: #323232;
    // background: #323232ed;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 111;

    .cookies-header {
        display: flex;
        padding: 1rem 0rem;
        align-items: baseline;
        text-align: center;
        justify-content: center;

        .hk-btn-cookies {
            // background: #6CC2B6;
            // background: #259384;
            background: #196155;

            color: $white;
            font-size: 1rem;
            border-radius: 20px;
            margin-left: 1rem;
            font-weight: 600;
            padding-right: 1.5rem;
            padding-left: 1.5rem;
        }

        p {
            font-size: 1rem;
            color: $white;
            margin-bottom: 0rem;
        }
    }

}

.modal-title {
    font-weight: 700;
}

.btn-close:focus {
    box-shadow: unset !important;
}

@media (max-width: 575.98px) {
    .cookies-header {
        display: block !important;

        button {
            margin-top: 0.5rem;
        }
    }

    .footer-mini .list-inline .list-inline-item {
        font-size: 12px;
    }

    .footer-mini .list-inline .list-inline-item a {
        font-size: 12px;
    }

    .footer-mini {
        padding-left: 5px;
        padding-right: 5px;
    }

    .m-fw-600 {
        font-weight: 600;
    }
}
</style>
